import { CHECK_LOGIN, LOGIN,SSOLOGIN, LOGOUT,FETCH_USER_BUSINESS_INFO, API_REQUEST_POST,API_REQUEST  } from '../constants/actionTypes';

import { serviceUrl } from '../../AppConfig';

export const checkLogin = (userData) => ({
  type: CHECK_LOGIN,
  payload: {
    username: userData.userName,
    password: userData.password,
    clang: userData.clang,
    createtimestamp: userData.createtimestamp,
    email: userData.email,
    hpclidnumber: userData.hpclidnumber,
    hpclname: userData.hpclname,
    hpresidentcountrycode: userData.hpresidentcountrycode,
    modifytimestamp: userData.modifytimestamp,
    preferredLanguage: userData.preferredLanguage,
    lastName: userData.lastName
  }
});

export const getUserBasicInfo = (hppSession) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'SizingEngine/GetPassportUserInfo',
    //url: 'http://localhost:60058/SizingEngine/GetPassportUserInfo',
    //data: {'sessionID' : hppSession},
    next: FETCH_USER_BUSINESS_INFO
  }
});

export const login = (isNonHPECOMDomain) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'SizingEngine/Login',
    //url: 'http://localhost:60058/SizingEngine/Login',
    next: LOGIN
  }
});

export const logOut = () => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'SizingEngine/LogOut',
    //url: 'http://localhost:60058/SizingEngine/LogOut',
    next: LOGOUT
  }
});

export const ssoLogin = () => ({
  type: API_REQUEST,
  payload: {
    url: serviceUrl+'SizingEngine/SSOLogin',
    //url: 'http://localhost:60058/SizingEngine/LogOut',
    next: SSOLOGIN
  }
});



// WEBPACK FOOTER //
// ./src/State/actions/authentication.js